import { sendMetric, getWhatId, pluralForm } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";

import img0 from "./img/0.webp";
import img1 from "./img/1.webp";
import img10 from "./img/10.webp";
import img11 from "./img/11.webp";
import img12 from "./img/12.webp";
import img13 from "./img/13.webp";
import img14 from "./img/14.webp";
import img15 from "./img/15.webp";
import img16 from "./img/16.webp";
import img17 from "./img/17.webp";
import img18 from "./img/18.webp";
import img19 from "./img/19.webp";
import img2 from "./img/2.webp";
import img20 from "./img/20.webp";
import img3 from "./img/3.webp";
import img4 from "./img/4.webp";
import img5 from "./img/5.webp";
import img6 from "./img/6.webp";
import img7 from "./img/7.webp";
import img8 from "./img/8.webp";
import img9 from "./img/9.webp";

const { VITE_WHAT_ID } = import.meta.env;

import "./style.scss";

const Face = inject("mainStore")(
    observer(({ mainStore }) => {
        const abTestMetika = mainStore.getMainStore("abTestMetika");
        const settingLego = mainStore.getMainStore("settingLego");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");

        const init = mainStore.getMainStore("init");

        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        const [activeIndex, setActiveIndex] = useState(1);
        const [seconds, setSeconds] = useState(settingLego.queueDuration || 5);
        const [shuffledData] = useState(() => {
            const shuffled = [...dataUsers].sort(() => Math.random() - 0.5);
            return shuffled.slice(0, 10);
        });

        useEffect(() => {
            const interval = setInterval(() => {
                setActiveIndex((prev) => (prev + 1) % dataUsers.length);
            }, 1000);

            const intervalSeconds = setInterval(() => {
                setSeconds((prev) => (prev > 0 ? prev - 1 : 1));
            }, 1000);

            return () => {
                clearInterval(interval);
                clearInterval(intervalSeconds);
            };
        }, []);

        useEffect(() => {
            if (seconds < 1) {
                sendMetric(`widget_step_1_show`, {
                    params1: [`${abTestMetika || "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: wdCd,
                    params8: what_id,
                });
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_1_show",
                        siteId: what_id, //'id витрины',
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }

                mainStore.setMainStore("isVisible", true);
                mainStore.setMainStore("modal", { type: "fortune" });
            }
        }, [seconds]);

        const title = settingLego.isPartnerHeaderVariant && init?.data?._p_n ? `Ваша очередь за подарками от\u00A0партнёров ${init.data._p_n} 🔎` : "Ожидайте вашу очередь ⏳";

        return (
            <div className="face" style={{ "--duration": settingLego.queueDuration + "s" }}>
                <span className="face__title" dangerouslySetInnerHTML={{ __html: title }}></span>
                <span className="face__sub">Перед вами несколько человек:</span>
                <div className="face__gifts-wrapper">
                    <div
                        className="face__gifts"
                        style={{
                            transform: `translateX(calc(50% - ${(activeIndex + 0.5) * 181}px))`,
                        }}
                    >
                        {shuffledData.map((user, idx) => (
                            <div className={`face__gift ${idx === activeIndex ? "face__gift_center" : ""}`} key={idx}>
                                <img src={user.img} className="face__gift-img" />
                                <div className="face__gift-text">
                                    <span className="face__gift-title">{user.title}</span>
                                    <br />
                                    <span className="face__gift-subtitle">{user.subtitle}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="face__center"></div>
                </div>

                <div className="face__bottom">
                    <div className="face__btn">
                        <span className="face__btn-text">
                            Ваша очередь наступит через {seconds} секунд{pluralForm(seconds, ["у", "ы", ""])}
                        </span>
                        <div className="face__progress"></div>
                    </div>
                </div>
            </div>
        );
    }),
);

export default Face;

const dataUsers = [
    { img: img0, title: "Максима", subtitle: "Проверяет почту" },
    { img: img1, title: "Tatyana    ", subtitle: "Смотрит оффер" },
    { img: img2, title: "Алекс", subtitle: "Выбирает подарок" },
    { img: img3, title: "Мари", subtitle: "Делится подарками" },
    { img: img4, title: "Иван", subtitle: "Записывается в зал" },
    { img: img5, title: "Владислав", subtitle: "Подключает подписку" },
    { img: img6, title: "Anna", subtitle: "Идет на процедуры" },

    { img: img7, title: "Nastya", subtitle: "Проверяет телефон" },
    { img: img8, title: "Карина", subtitle: "Делает заказ" },
    { img: img9, title: "Max", subtitle: "Учит английский" },
    { img: img10, title: "Alena", subtitle: "Выбирает фильм" },
    { img: img11, title: "Ivan", subtitle: "Записывается в зал" },
    { img: img12, title: "Aleksei", subtitle: "Продлил подписку" },
    { img: img13, title: "Anna", subtitle: "Идет на процедуры" },

    { img: img14, title: "Olga", subtitle: "Читает описание" },
    { img: img15, title: "Tatyana", subtitle: "Открывает оффер" },
    { img: img16, title: "Belov", subtitle: "Заказывает ужин" },
    { img: img17, title: "Petrova", subtitle: "Нашла курсы" },
    { img: img18, title: "Павел", subtitle: "Выбирает промокод" },
    { img: img19, title: "Dmitrii", subtitle: "Отправляет подарок" },
    { img: img20, title: "Люда", subtitle: "Выбирает карту" },
];
